import { FeedbackForBookingDto } from '@mopla/data-models';

export const getAverageRating = (feedbacks: FeedbackForBookingDto[]) => {
	const filteredFeedbacks = feedbacks.filter(({ rating }) =>
		Number.isInteger(rating)
	);

	const sum = filteredFeedbacks.reduce(
		(acc, feedback) => acc + (feedback.rating as number),
		0
	);

	return Math.round((sum * 10) / filteredFeedbacks.length) / 10;
};
